var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4556 38.7081C30.9346 38.7081 38.6188 31.0239 38.6188 21.545C38.6188 12.066 30.9346 4.38184 21.4556 4.38184C11.9767 4.38184 4.29248 12.066 4.29248 21.545C4.29248 31.0239 11.9767 38.7081 21.4556 38.7081Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92554 32.1048C11.533 24.6336 9.3848 14.9648 15.2035 13.4433C21.0222 11.9217 24.8276 14.517 27.8723 15.4126C30.917 16.3083 33.4428 16.7825 34.0047 19.6196C34.8102 23.6949 21.5595 30.893 24.3806 38.7082",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7389 23.9174C24.2902 25.9314 26.9246 25.2625 32.752 22.8213M26.1247 14.789C26.1247 12.9745 22.8134 11.5176 20.761 13.1293",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0984 20.2917C20.5568 20.2917 21.7391 19.1094 21.7391 17.6509C21.7391 16.1925 20.5568 15.0102 19.0984 15.0102C17.6399 15.0102 16.4576 16.1925 16.4576 17.6509C16.4576 19.1094 17.6399 20.2917 19.0984 20.2917Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0984 18.6806C19.6671 18.6806 20.1282 18.2196 20.1282 17.6508C20.1282 17.0821 19.6671 16.621 19.0984 16.621C18.5297 16.621 18.0686 17.0821 18.0686 17.6508C18.0686 18.2196 18.5297 18.6806 19.0984 18.6806Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2284 20.7395C30.2284 20.8051 30.1753 20.8582 30.1098 20.8582C30.0442 20.8582 29.9911 20.8051 29.9911 20.7395C29.9911 20.674 30.0442 20.6208 30.1098 20.6208C30.1753 20.6208 30.2284 20.674 30.2284 20.7395Z",
    fill: "black",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1241 20.7387C35.9252 17.1302 34.4033 13.7216 31.8493 11.1647C29.2953 8.60778 25.8885 7.08191 22.2803 6.87885",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.b2310ced93c2d2f68b8c690390036db2.svg";
export { ForwardRef as ReactComponent };